var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTexttospeech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.695,
    height: 59.109,
    viewBox: "0 0 50.695 59.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.001 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.168,4.644a.986.986,0,0,0,.887-1.76,27.435,27.435,0,0,0-24.487,0,.986.986,0,0,0,.887,1.76,25.473,25.473,0,0,1,22.722,0Z",
    transform: "translate(-0.46 0)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.578,18a.985.985,0,0,0,.9-1.379A27.569,27.569,0,0,0,42.023,5.066a.986.986,0,0,0-1.129,1.616,25.6,25.6,0,0,1,8.781,10.729.985.985,0,0,0,.9.591Z",
    transform: "translate(-0.867 -0.073)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.861,17.921a.985.985,0,0,0,1.3-.509A25.6,25.6,0,0,1,10.939,6.682.985.985,0,0,0,9.812,5.068,27.569,27.569,0,0,0,.353,16.624a.985.985,0,0,0,.508,1.3Z",
    transform: "translate(-0.27 -0.073)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.688,9.517a.985.985,0,0,0,.38-1.894,21.621,21.621,0,0,0-16.4,0,.985.985,0,0,0,.759,1.819,19.665,19.665,0,0,1,14.886,0,.975.975,0,0,0,.378.076Z",
    transform: "translate(-0.519 -0.089)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.946,19.264a.986.986,0,0,0,1.779-.848,21.619,21.619,0,0,0-7.639-8.768A.986.986,0,1,0,37,11.295,19.639,19.639,0,0,1,43.946,19.264Z",
    transform: "translate(-0.809 -0.141)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.136,18.416a.986.986,0,1,0,1.779.848A19.639,19.639,0,0,1,14.856,11.3a.986.986,0,0,0-1.084-1.647A21.619,21.619,0,0,0,6.136,18.416Z",
    transform: "translate(-0.356 -0.141)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.971,12.516a.985.985,0,1,0,.508,1.9,13.537,13.537,0,0,1,6.9,0,.985.985,0,0,0,.508-1.9A15.513,15.513,0,0,0,21.971,12.516Z",
    transform: "translate(-0.581 -0.178)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.123,15.932A13.891,13.891,0,0,1,38.2,21.175a.985.985,0,1,0,1.726-.951,15.878,15.878,0,0,0-5.8-5.988.985.985,0,1,0-1,1.7Z",
    transform: "translate(-0.751 -0.209)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.761,14.237a15.878,15.878,0,0,0-5.8,5.988.985.985,0,1,0,1.726.951,13.891,13.891,0,0,1,5.077-5.243.985.985,0,1,0-1-1.7Z",
    transform: "translate(-0.442 -0.209)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.733,54.421H32.924a.978.978,0,0,1,.569.181l6.384,4.56a.985.985,0,0,0,1.559-.8V55.406a.985.985,0,0,1,.985-.985h.985a2.955,2.955,0,0,0,2.955-2.955V36.688a2.955,2.955,0,0,0-2.955-2.955H33.555V28.807a2.955,2.955,0,0,0-2.266-2.866,5.764,5.764,0,0,0-2.758-3.3,3.941,3.941,0,1,0-5.714,0,5.782,5.782,0,0,0-2.714,3.21H6.955A2.955,2.955,0,0,0,4,28.807V44.569a2.955,2.955,0,0,0,2.955,2.955h.985a.985.985,0,0,1,.985.985v2.955a.985.985,0,0,0,.985.985.973.973,0,0,0,.572-.184l6.383-4.557a.969.969,0,0,1,.572-.184h1.339v3.941A2.955,2.955,0,0,0,21.733,54.421ZM43.406,35.7a.985.985,0,0,1,.985.985V51.465a.985.985,0,0,1-.985.985h-.985a2.955,2.955,0,0,0-2.955,2.955v1.041L34.638,53a2.944,2.944,0,0,0-1.714-.549H21.733a.985.985,0,0,1-.985-.985V47.525H30.6a2.955,2.955,0,0,0,2.955-2.955V35.7ZM23.7,19.94a1.97,1.97,0,1,1,1.97,1.97A1.97,1.97,0,0,1,23.7,19.94Zm1.99,3.941a3.985,3.985,0,0,1,3.419,1.97H22.254A4,4,0,0,1,25.693,23.881Zm-9.97,22.224L10.9,49.553V48.51a2.955,2.955,0,0,0-2.955-2.955H6.955a.985.985,0,0,1-.985-.985V28.807a.985.985,0,0,1,.985-.985H30.6a.985.985,0,0,1,.985.985V44.569a.985.985,0,0,1-.985.985H17.439a2.938,2.938,0,0,0-1.715.551Z",
    transform: "translate(-0.326 -0.237)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.955,34a2.955,2.955,0,1,0,2.955,2.955A2.955,2.955,0,0,0,18.955,34Zm0,3.941a.985.985,0,1,1,.985-.985A.985.985,0,0,1,18.955,37.941Z",
    transform: "translate(-0.504 -0.505)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.955,34a2.955,2.955,0,1,0,2.955,2.955A2.955,2.955,0,0,0,10.955,34Zm0,3.941a.985.985,0,1,1,.985-.985A.985.985,0,0,1,10.955,37.941Z",
    transform: "translate(-0.385 -0.505)",
    fill: "#0080ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.955,34a2.955,2.955,0,1,0,2.955,2.955A2.955,2.955,0,0,0,26.955,34Zm0,3.941a.985.985,0,1,1,.985-.985A.985.985,0,0,1,26.955,37.941Z",
    transform: "translate(-0.623 -0.505)",
    fill: "#0080ff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTexttospeech);
export default __webpack_public_path__ + "static/media/texttospeech.68f9596e.svg";
export { ForwardRef as ReactComponent };